import app from 'flarum/common/app';
import Icon from 'flarum/common/components/Icon';

/** Настройки SUBLACE, которые сервер отдаёт в атрибуте форума `sublace`. */
export function sublace() {
  return app.forum && app.forum.attribute('sublace') || {};
}
export function statuses() {
  return sublace().statuses || [];
}
export function statusOf(key) {
  return statuses().find(s => s.key === key) || null;
}

/** Настройки раздела (шаблон, статусы) для тега; дочерний раздел важнее родителя. */
export function configForTags(tags) {
  const all = sublace().tagConfig || {};
  const list = (tags || []).filter(Boolean);
  const ordered = list.filter(t => t.parent && t.parent()).concat(list.filter(t => !(t.parent && t.parent())));
  for (const tag of ordered) {
    const config = all[tag.id()];
    if (config) return {
      tag,
      ...config
    };
  }
  return null;
}
export function configForTag(tag) {
  return tag ? configForTags([tag]) : null;
}

/** Метка статуса темы: <StatusLabel status={...} small />. */
export const StatusLabel = {
  view(vnode) {
    const {
      status,
      small
    } = vnode.attrs;
    if (!status) return null;
    return m("span", {
      className: 'SublaceStatus' + (small ? ' SublaceStatus--small' : ''),
      style: {
        '--status-color': status.color
      },
      title: status.label
    }, status.icon ? m(Icon, {
      name: status.icon
    }) : null, m("span", {
      className: "SublaceStatus-label"
    }, status.label));
  }
};
export function plural(n, one, few, many) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
export function formatNumber(n) {
  const value = Number(n) || 0;
  if (value >= 1000000) return (value / 1000000).toFixed(value >= 10000000 ? 0 : 1).replace('.0', '') + 'M';
  if (value >= 10000) return (value / 1000).toFixed(value >= 100000 ? 0 : 1).replace('.0', '') + 'K';
  return value.toLocaleString('ru-RU');
}

/** Безопасная ссылка из настроек: http(s), mailto или путь от корня. */
export function safeUrl(url) {
  return typeof url === 'string' && (/^(https?:\/\/|mailto:)[^\s<>"']+$/i.test(url) || /^\/(?!\/)/.test(url) && !/[\s<>"']/.test(url));
}

/** Внутренние ссылки ведём через роутер Flarum, внешние — обычным переходом. */
export function linkAttrs(link) {
  const external = /^(https?:|mailto:)/i.test(link.url);
  let href = link.url;
  if (!external) {
    const base = m.route.prefix === '' ? (app.forum.attribute('basePath') || '').replace(/\/$/, '') : '';
    href = base + link.url;
  }
  return {
    href,
    external,
    target: link.newTab ? '_blank' : undefined,
    rel: link.newTab || external ? 'noopener noreferrer' : undefined
  };
}
flarum.reg.add('sublace-forum', 'common/sublace', { sublace: sublace,statuses: statuses,statusOf: statusOf,configForTags: configForTags,configForTag: configForTag,StatusLabel: StatusLabel,plural: plural,formatNumber: formatNumber,safeUrl: safeUrl,linkAttrs: linkAttrs, });